import Typography from '../../../typography';
import styled from 'styled-components';

export const CalendarPlaceholderSC = styled(Typography)`
  position: absolute;
  z-index: 0;
  top: 0;
  left: 0;
  pointer-events: none;

  .value-placeholder {
    color: ${({ theme }) => theme.color.tint.tertiary};
    ${({ theme }) => theme.mappedTypography.body2.strong};
  }

  &.on-dark,
  .on-dark & {
    .value-placeholder {
      color: ${({ theme }) => theme.color.tint.tertiaryDark};
    }
  }
`;
